// @ts-ignore: module 'posthog-js' has no type declarations or is not installed
import posthog from 'posthog-js';

const posthogKey = process.env.REACT_APP_POSTHOG_KEY;
if (posthogKey) {
  posthog.init(posthogKey, {
    api_host: process.env.REACT_APP_POSTHOG_HOST,
    capture_pageview: false
  });
}

//export default posthog;

export const postHogCaptureAnalitics = async (key: any, value:any) => {
    console.log('Posthog Capture::', key, value);

    posthog.capture("tp." + key, value);
}